module.exports = __webpack_public_path__ + "img/IMG-20200608-WA0014.3db0de7d.jpg";